var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconButton',_vm._g({staticClass:"button-secondary button-full",attrs:{"to":_vm.url,"icon":"google"}},_vm.$listeners),[_vm._t("default",[_vm._v("Log In with Google")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }